// eslint-disable-next-line
export function get(state) {}

// eslint-disable-next-line
export function isMapDisplayed(state) {
  // console.log('ui/getters isMapDisplayed()', state.displayMap);
  return state.displayMap;
}

export function getPanelView(state) {
  return state.panelView;
}

export function getDetailedCommunity(state) {
  return state.mapDetailCommunity;
}

export function getDetailedQuickMoveIn(state) {
  return state.mapDetailQuickMoveIn;
}

export function getZoomToLocation(state) {
  return state.zoomToLocation;
}
